import './TicketProcessBuy.scss';
import Button from "react-bootstrap/Button";
import React from "react";
import InputGroup from 'react-bootstrap/InputGroup';
import Form from "react-bootstrap/Form";
import DatePicker from "react-datepicker";
import {Badge, ButtonGroup} from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const TicketProcessBuy = ({ticket}) => {
    console.log("TicketProcessBuy");
    console.log(ticket);

    const [step, setStep] = React.useState("quantity");
    const [quantity, setQuantity] = React.useState(1);
    const [index, setIndex] = React.useState(1);
    const [dateStart, setDateStart] = React.useState(new Date());
    const [dateEnd, setDateEnd] = React.useState(new Date());

    const nextStep = () => {
        if (step === "quantity") {
            setStep("setDate");
            setIndex(1);
        } else {
            if (step === "setDate") {
                setStep("setNickname");
            }
            if(step === "setNickname") {
                if(Object.keys(ticket.extra_data).length > 0) {
                    setStep("setExtraData");
                }else{
                    setStep("summary");
                }
            }
        }
    }

    const getContent = () => {
        let content = [];
        switch (step) {
            case "quantity":
                content.push(<div className={"step-quantity"}>
                    <h4>Quanti ticket vuoi acquistare?</h4>
                    <hr/>
                    <InputGroup className="mb-3">
                        <Button variant="danger" onClick={() => setQuantity(quantity - 1)}>
                            Rimuovi
                        </Button>
                        <Form.Control
                            aria-label="Quantità"
                            aria-describedby="basic-addon1"
                            placeholder="Quantità"
                            type="number"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                        />
                        <Button variant="success" onClick={() => setQuantity(quantity + 1)}>
                            Aggiungi
                        </Button>
                    </InputGroup>
                    <Button variant="success" onClick={() => nextStep()}>
                        Conferma
                    </Button>
                </div>);
                break;
            case "setDate":
                content.push(<div className={"step-date"}>
                    <Badge className={"ticket-number"}>Ticket n°{index}</Badge>
                    <h4>Imposta le date per questo ticket</h4>
                    <hr/>
                    <Row>
                        <Col>
                            <label>Data inizio</label>
                            <DatePicker
                                selected={dateStart}
                                onChange={(date) => setDateStart(date)}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                            />
                        </Col>
                        <Col>
                            <label>Data fine</label>
                            <DatePicker
                                selected={dateEnd}
                                onChange={(date) => setDateEnd(date)}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                            />
                        </Col>
                    </Row>
                    <ButtonGroup aria-label="Basic example">
                        <Button variant="light">
                            Indietro
                        </Button>
                        <Button variant="success" onClick={() => nextStep()}>
                            Continua
                        </Button>
                    </ButtonGroup>
                </div>);

                break;
            case "setNickname":
                content.push(<div className={"step-date"}>
                    <Badge className={"ticket-number"}>Ticket n°{index}</Badge>
                    <h4>Imposta il nominativo per questo ticket</h4>
                    <hr/>
                    <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Nominativo sul ticket</Form.Label>
                            <Form.Control type="text" placeholder="Nominativo"/>
                        </Form.Group>
                    </Form>
                    <ButtonGroup aria-label="Basic example">
                        <Button variant="light">
                            Indietro
                        </Button>
                        <Button variant="success" onClick={() => nextStep()}>
                            Continua
                        </Button>
                    </ButtonGroup>
                </div>);

                break;

            case "setExtraData":
                content.push(<div className={"step-date"}>TODO</div>)
        break;
            case "summary":
                content.push(<div className={"step-date"}>TODO</div>)
                break;
        }
        return content;
    }

    return (
        <div className="ticket-buy-container">
            {getContent()}
        </div>
    );
};

export default TicketProcessBuy;
